import { css } from '@emotion/react';

export const container = css({
  padding: '0 90px'
});
